import React, { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { MdHelpOutline } from '../../../Common/Icons';
import DeleteIcon from '../../../Assets/General/DeleteIcon';
import AddContact from '../../../Pages/Contact/AddContact';
import {
  checkError,
  setObjInLS,
  restRequest,
  getObjFromLS,
  hasPermissionCustom,
} from '../../../Helpers';
import Form from './../../Form/Form';
import ErrorFocus from '../ErrorFocus';
import FormAction from '../FormAction';
import Field from './../../Form/Field/Field';
import TaxForm from '../../Form/TaxForm/TaxForm';
import SmallLoader from '../../SmallLoader/SmallLoader';
import CustomModal from '../../CustomModal/CustomModal';
import ImagePreview from '../../ImagePreview/ImagePreview';
import FormSection from './../../Form/FormSection/FormSection';
import { formSubmit, getError, validate } from '../FormHelper';
import ImageCropper from '../../../Components/Cropper/ImageCropper';
import AccountForm from '../../../Pages/ChartOfAccounts/AccountForm';
import ItemAccountsIcon from '../../../Assets/General/ItemAccountsIcon';
import { validateCreateItemGroupFormStepOne } from '../../../Helpers/FormValidator';
import {
  required,
  ValidateMax50,
  ValidateMax15,
  ValidateMax200,
  ValidateMax240,
  // ValidateMax255,
  wrapValidateMax,
  ValidateRequired,
  ValidateMax10Billion,
  ValidateMax1000,
} from '../../../Helpers/Validator';
import './ItemGroup.css';
import PopOver from '../../../Common/Popover';
import OldAccount from '../../../Pages/Account/AccountForm';
import { useTranslation } from 'react-i18next';

// const skipButton = localStorage.getItem('skipBtnoldAccount');
const getYupValidationSchema = (_, props) => {
  return Yup.object().shape({
    description: ValidateMax1000,
    manufacturer: ValidateMax200,
    unit: required(ValidateMax15),
    name: required(ValidateMax240),
    salesAccountID: ValidateRequired,
    purchaseAccountID: ValidateRequired,
    brand: wrapValidateMax(Yup.string().nullable().trim(), 200),
    attributesArr:
      props.type === 'add'
        ? Yup.array().of(
            Yup.lazy((attr) => {
              return Yup.object().shape({
                attribute: required(ValidateMax50),
              });
            })
          )
        : Yup.mixed().notRequired(),
    itemsList:
      props.type === 'add'
        ? Yup.array().of(
            Yup.lazy((item) => {
              return Yup.object().shape({
                name: ValidateRequired,
                sku: required(ValidateMax50),
                costPrice: ValidateMax10Billion,
                reorderPoint: ValidateMax10Billion,
                sellingPrice: ValidateMax10Billion,
                upc: wrapValidateMax(Yup.string().nullable(), 13),
                ean: wrapValidateMax(Yup.string().nullable(), 14),
                isbn: wrapValidateMax(Yup.string().nullable(), 17),
              });
            })
          )
        : Yup.mixed().notRequired(),
  });
};
// let modalflag = false;
const formEnhancer = withFormik({
  validate: validate(getYupValidationSchema),
  mapPropsToValues: ({ item }) => ({
    ...item,
    loadingAccounts: {
      salesAccounts: false,
      purchaseAccounts: false,
    },
    showTaxModal: false,
    showAccountModal: false,
    showImageCropModal: false,
    showContactCreateModal: false,
  }),
  mapPropsToStatus: (props) => ({
    accountType: '', // sales, purchase
    itemsList: [],
    taxList: props.taxList,
    currency: props.currency,
    emptyItem: props.emptyItem,
    vendorsList: props.vendorsList,
    allWarehouses: props.allWarehouses,
    salesAccounts: props.salesAccounts,
    warehousesList: props.warehousesList,
    emptyWarehouse: props.emptyWarehouse,
    purchaseAccounts: props.purchaseAccounts,
  }),
  handleSubmit: (values, bag, t) => {
    handleFormSubmit(values, bag, t);
  },
});
const handleFormSubmit = (
  values,
  {
    setSubmitting,
    props: {
      type,
      history,
      setPrompt,
      requestUrl,
      updateStep,
      handleToast,
      trackInventory,
      successMessage,
      inModal: inModalItem,
      closeModal: closeItem,
      onSubmit: onSubmitItem,
    },
    t,
  }
) => {
  let checkOptions = values.attributesArr.filter(
    (opt) => opt.variations.options && opt.variations.options.length === 0
  );
  if (checkOptions && checkOptions.length > 0 && type === 'add') {
    handleToast(t('Items.options_required'), 'error');
    setSubmitting(false);
    return;
  }
  if (type === 'add' && values.itemsList.length === 0) {
    handleToast(t('Items.at_least_one_item_required'), 'error');
    setSubmitting(false);
    return;
  }
  let newItemsList = [];
  let attributesValues = [];
  if (type === 'add') {
    newItemsList = values.itemsList.map((item) => ({
      name: item.name,
      upc: item.upc,
      sku: item.sku,
      ean: item.ean,
      isbn: item.isbn,
      variant: item.variant,
      reorder_level: item.reorderPoint || 0,
      purchase_unit_price: item.costPrice || 0,
      sales_unit_price: item.sellingPrice || 0,
      opening_stock_value: item.purchase_unit_price,
    }));
    attributesValues = values.attributesArr.map((item, index) => {
      return {
        attr: item.attribute,
        options: item.variations.options,
      };
    });
  }
  let data = new FormData();
  data.append('type', values.type);
  data.append('name', values.name);
  data.append('unit', values.unit);
  data.append('brand', values.brand);
  data.append('description', values.description);
  data.append('manufacturer', values.manufacturer);
  values.taxID && data.append('tax_id', values.taxID);
  values.salesAccountID &&
    data.append('sales_account_id', values.salesAccountID);
  values.purchaseAccountID &&
    data.append('purchase_account_id', values.purchaseAccountID);
  for (let [index, imageUrl] of values.images.entries()) {
    data.append(`images[${index}]`, imageUrl);
  }
  for (let [index, file] of values.base84Image.entries()) {
    data.append(`base84Image[${index}]`, file);
  }
  if (type === 'add') {
    for (let [index, item] of newItemsList.entries()) {
      data.append(`items[${index}]`, JSON.stringify(item));
    }
    for (let [index, attr] of attributesValues.entries()) {
      data.append(`attributes[${index}]`, JSON.stringify(attr));
    }
  }
  restRequest('post', requestUrl, data)
    .then((res) => {
      setPrompt(false);
      if (inModalItem) {
        onSubmitItem(res);
        closeItem();
      } else {
        successMessage();
        let dataFromLS = getObjFromLS('module');
        if (dataFromLS === null) {
          let obj = {
            id: null,
            prevId: null,
            nextId: null,
            moduleName: 'item_groups',
            urlPath: '/item-groups',
            queryParam: window.location.search,
          };
          setObjInLS('module', obj);
          dataFromLS = getObjFromLS('module');
        }
        if (type === 'add') {
          res.data.items.map((el) => {
            if (el) {
              el['trackInventory'] = trackInventory;
              el['warehouses'] = [values.warehouses[0]];
              el['warehouses'][0].openingStockValue = el.opening_stock_value;
              el['warehousesList'] = [];
            }
          });
          setObjInLS('itemsList', res.data.items);
          setObjInLS('itemGroup', res.data.item_group);
          values.itemsList && updateStep();
        } else if (type === 'clone') {
          setObjInLS('module', {
            ...dataFromLS,
            moduleName: 'item_groups',
            queryParam: dataFromLS.dataFromLS ? dataFromLS.dataFromLS : '',
            id: type === 'clone' ? res.data.id : dataFromLS.id,
            urlPath: '/item-groups',
          });
          return history.push('/r');
        }
        if (type === 'edit') {
          if (res.data.editStocks && res?.data?.items.length !== 0) {
            res.data.items.map((el) => {
              if (el) {
                el['trackInventory'] =
                  el.inventory_type === 'inventory' ? true : false;
                el['warehousesList'] = [];
                el['warehouses'] =
                  el.stocks.length === 0
                    ? [values.warehouses[0]]
                    : el.stocks.map((stock) => ({
                        id: stock.warehouse.id,
                        name: stock.warehouse.name,
                        address: stock.warehouse.address,
                        city: stock.warehouse.city,
                        state: stock.warehouse.state,
                        country: stock.warehouse.country
                          ? stock.warehouse.country.country_name
                          : '',
                        zipCode: stock.warehouse.zip_code,
                        openingStock: stock.opening_quantity,
                        openingStockValue: el.opening_stock_value,
                        is_active: 1,
                      }));
              }
            });
            setObjInLS('itemsList', res.data.items);
            setObjInLS('itemGroup', res.data.item_group);
            values.itemsList && updateStep();
          } else {
            setObjInLS('module', {
              ...dataFromLS,
              action: type === 'add' ? 'add' : 'justedit',
              queryParam: dataFromLS.queryParam ? dataFromLS.queryParam : '',
            });
            return history.push('/r');
          }
        }
      }
    })
    .catch((error) => {
      checkError(error);
      handleToast(error, 'error');
      setSubmitting(false);
    });
};

const ItemGroupForm = ({
  type,
  values,
  status,
  errors,
  history,
  touched,
  setValues,
  setStatus,
  handleBlur,
  submitCount,
  suggestions,
  handleToast,
  handleChange,
  handleSubmit,
  isSubmitting,
  setFieldValue,
  allWarehouses,
  trackInventory,
  warehousesList,
  setFieldTouched,
  removeSuggestion,
  submitButtonText,
  inModal: inModalItem,
  attributeSuggestions,
  closeModal: closeItem,
  onSuggestionsFetchRequested,
  onSuggestionsClearRequested,
  onSuggestionsClearRequestedAttribute,
  onSuggestionsFetchRequestedAttribute,
  ...props
}) => {
  // let validation;
  const { t } = useTranslation();
  var base64Images = [];
  const [num, setNum] = useState(1);
  const [createComboFlag] = useState(true);
  const [comboList, setComboList] = useState([]);
  const [staticVal, setStaticValues] = useState({});
  const [comboFlag, setComboFlag] = useState(true);
  const [showPrompt, setShowPrompt] = useState(false);
  const [popovers, setPopovers] = useState({
    costPrice: false,
    sellingPrice: false,
    reorderPoint: false,
  });
  const [skipButton, setskipButton] = useState(
    localStorage.getItem('skipBtnoldAccount')
  );
  useEffect(() => {
    setskipButton(JSON.parse(localStorage.getItem('skipBtnoldAccount')));
  }, [skipButton]);
  useEffect(() => {
    handleAlert();
    // eslint-disable-next-line
  }, [values, comboFlag, comboList, staticVal]);
  useEffect(() => {
    let itemsList = [];
    setStaticValues({
      ...values,
      comboList,
      itemsList,
      attributesArr: [
        {
          attribute: '',
          variations: { options: [] },
        },
      ],
    });
    // eslint-disable-next-line
  }, []);

  const handleAlert = () => {
    let { checkout } = validateCreateItemGroupFormStepOne(
      {
        ...values,
        comboList,
      },
      staticVal
    );
    if (!checkout) props.setPrompt();
    else props.setPrompt(false);
  };

  useEffect(() => {
    handleCombination();
    // eslint-disable-next-line
  }, [comboFlag, values.name]);

  useEffect(() => {
    values['itemsList'] = [...status.itemsList];
    // eslint-disable-next-line
  }, [status]);

  const handleFiles = (accepted, rejected) => {
    const allowedExtensions = ['image/png', 'image/jpg', 'image/jpeg'];

    const allTypes = accepted.map((data) => data?.type);
    const hasInvalidType = allTypes?.some(
      (type) => !allowedExtensions.includes(type)
    );
    const hasJfif = accepted.some((file) =>
      file.name.toLowerCase().endsWith('.jfif')
    );
    if (hasInvalidType || hasJfif) {
      handleToast(t('Items.invalid_file'), 'error');

      return null;
    }
    if (rejected.length) {
      if (rejected.length === 1) {
        handleToast(t('Items.invalid_file'), 'error');
      } else {
        handleToast(`${rejected.length} ${t('Items.invalid_files')}`, 'error');
      }
    }

    if (accepted.length) {
      let previousFiles = [...values.uploadImages];
      if ([...previousFiles, ...accepted].length > 5) {
        handleToast(t('Items.max_images'), 'error');
        return null;
      }
      let updatedFiles = accepted.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      if (
        values.images.length +
          values.uploadImages.length +
          updatedFiles.length >
        5
      ) {
        handleToast(t('Items.max_images'), 'error');
        return null;
      }
      setFieldValue('imageUpload', [...previousFiles, ...updatedFiles]);
      setFieldValue('showImageCropModal', true);
    }
  };

  const handleImageDelete = (image) => {
    if (typeof image === 'string') {
      // previous uploaded image (url)
      setFieldValue(
        'images',
        values.images.filter((el) => el !== image)
      );
    } else {
      setFieldValue(
        'uploadImages',
        values.uploadImages.filter((el) => el !== image)
      );
      setFieldValue(
        'base84Image',
        values.base84Image.filter((el) => el !== image.preview)
      );
    }
  };

  const handleTaxChange = (option) => {
    if (option !== null) {
      // Add New
      if (option.value === 'createNew') {
        setFieldValue('showTaxModal', true);
      } else {
        // tax selected
        const taxID = option.value;
        setFieldValue('taxID', taxID);
      }
    } else {
      // deselect tax
      setFieldValue('taxID', null);
    }
  };

  const handleAccountModal = (accountType) => {
    // sales, purchase
    setStatus({
      ...status,
      accountType:
        accountType === 'sales'
          ? 'sales'
          : accountType === 'inventory'
          ? 'inventory'
          : 'expense',
    });
    setFieldValue('showAccountModal', true);
  };

  function closeModal() {
    setValues({
      ...values,
      showTaxModal: false,
      showAccountModal: false,
      showImageCropModal: false,
      showContactCreateModal: false,
    });
  }

  const updateAccount = (accountType, newAccount) => {
    if (skipButton) {
      const fieldName =
        accountType === 'sales' ? 'salesAccountID' : 'purchaseAccountID';
      const accountList =
        accountType === 'sales'
          ? status.salesAccounts
          : status.purchaseAccounts;

      const updatedAccountList = [...accountList, newAccount];
      if (accountType === 'sales') {
        setStatus({ ...status, salesAccounts: updatedAccountList });
      } else {
        setStatus({ ...status, purchaseAccounts: updatedAccountList });
      }
      closeModal();
      setFieldValue(fieldName, newAccount.id);
    } else {
      const fieldName =
        accountType === 'sales'
          ? 'salesAccountID'
          : accountType === 'expense'
          ? 'purchaseAccountID'
          : 'inventoryAccountID';

      const accountList =
        accountType === 'sales'
          ? status.salesAccounts
          : accountType === 'expense'
          ? status.purchaseAccounts
          : status.inventoryAccounts;
      const updatedAccountList = [...accountList, newAccount.data];

      if (accountType === 'sales') {
        setStatus({ ...status, salesAccounts: updatedAccountList });
      } else if (accountType === 'expense') {
        setStatus({ ...status, purchaseAccounts: updatedAccountList });
      } else {
        setStatus({ ...status, inventoryAccounts: updatedAccountList });
      }
      setFieldValue(fieldName, newAccount.data.id);
    }
  };

  const accountDropDownField = (accountType) => (
    <div className="flex-50 position-relative">
      <Field
        size="large"
        type="dropdown"
        dropdownValue="id"
        dropdownLabel="title"
        name={`${t(`Items.${accountType}`)} ${t('Items.account')}`}
        className="overForm w-100 flex-100"
        value={
          accountType === 'sales'
            ? values.salesAccountID
            : values.purchaseAccountID
        }
        id={accountType === 'sales' ? 'salesAccountID' : 'purchaseAccountID'}
        options={
          accountType === 'sales'
            ? status.salesAccounts || []
            : status.purchaseAccounts || []
        }
        handleChange={(option) => {
          setFieldValue(
            accountType === 'sales' ? 'salesAccountID' : 'purchaseAccountID',
            option.value
          );
        }}
        clearable={false}
      />
      {/* {!inModalItem && hasPermissionCustom('account', 'Create') && (
        <button
          type="button"
          onClick={() => handleAccountModal(accountType)}
          disabled={!hasPermissionCustom('account', 'Create')}
          className="button form-field--side-btn account_addnew new_click_set"
        >
          {t('Items.add_new')}
        </button> */}
      {/* )} */}
    </div>
  );
  const handlePrompt = (status = true) => setShowPrompt(status);
  /*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/
  String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  };
  const newAccountModal = () => {
    let { accountType } = status;
    return (
      <CustomModal
        fill="#000000"
        className="widthClass"
        onClose={closeModal}
        renderActions={false}
        Icon={ItemAccountsIcon}
        showPrompt={showPrompt}
        classNames="new-sales-account"
        showModal={values.showAccountModal}
        title={`${t('Items.new')} ${t(`Items.${accountType}`).capitalize()} ${t(
          'PurchaseOrder.account'
        )}`}
      >
        <AccountForm
          itemModal
          accountType={
            accountType === 'sales'
              ? 'income'
              : accountType === 'inventory'
              ? 'inventory'
              : 'expense'
          }
          inModal
          history={history}
          onClose={closeModal}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
          onSubmitForm={(account) => updateAccount(accountType, account)}
        />
      </CustomModal>
    );
  };
  const oldAccountModal = () => {
    let { accountType } = status;
    return (
      <CustomModal
        fill="#000000"
        onClose={closeModal}
        className="widthClass"
        renderActions={false}
        Icon={ItemAccountsIcon}
        showPrompt={showPrompt}
        showModal={values.showAccountModal}
        title={`New ${accountType.capitalize()} Account`}
      >
        <OldAccount
          inModal
          history={history}
          onClose={closeModal}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
          onSubmit={(account) => updateAccount(accountType, account)}
          accountType={accountType === 'sales' ? 'sales' : 'purchase'}
        />
      </CustomModal>
    );
  };
  const contactCreateModal = () => (
    <CustomModal
      size="large"
      title={t('Item.add_contact')}
      onClose={closeModal}
      renderActions={false}
      customWidth="contact-modal-width"
      showModal={values.showContactCreateModal}
    >
      <AddContact
        inModal
        type="purchaseOrder"
        onSubmit={(res) => {
          var vendor = res.data;
          vendor.value = res.data.id;
          status.vendorsList.push(res.data);
          setStatus({
            ...status,
            vendorsList: [...status.vendorsList, res.data],
          });
          setValues({
            ...values,
            vendorID: res.data.id,
            showContactCreateModal: false,
          });
        }}
        handleToast={handleToast}
      />
    </CustomModal>
  );

  const newTaxModal = () => (
    <CustomModal
      title={t('Items.item_new_tax')}
      onClose={closeModal}
      renderActions={false}
      showPrompt={showPrompt}
      className="smallWidthClass"
      showModal={values.showTaxModal}
    >
      <TaxForm
        inModal
        type="add"
        onSubmitModal={(newitem) => {
          setStatus({
            ...status,
            taxList: [newitem, ...status.taxList],
          });
          setValues({
            ...values,
            taxID: newitem.id,
            showTaxModal: false,
          });
        }}
        closeModal={closeModal}
        handleToast={handleToast}
        handlePrompt={handlePrompt}
      />
    </CustomModal>
  );
  const hanldeImageUpload = (updatedFiles, croppedImage) => {
    updatedFiles[updatedFiles.length - 1].preview = croppedImage;
    updatedFiles.forEach((el) => {
      base64Images.push(el.preview);
      setFieldValue('base84Image', base64Images);
    });
    setFieldValue('uploadImages', updatedFiles);
    setFieldValue('showImageCropModal', false);
  };
  const ImageCropModal = () => (
    <CustomModal
      onClose={closeModal}
      renderActions={false}
      className="smallWidthClass"
      title={t('Items.adjust_image')}
      showModal={values.showImageCropModal}
    >
      <ImageCropper
        inModal
        type="add"
        updatedFiles={values.imageUpload}
        onSubmitModal={(updatedFiles, croppedImage) => {
          hanldeImageUpload(updatedFiles, croppedImage);
        }}
        closeModal={closeModal}
        handleToast={handleToast}
      />
    </CustomModal>
  );
  const renderModals = () => {
    return (
      <Fragment>
        {newTaxModal()}
        {ImageCropModal()}
        {contactCreateModal()}
        {JSON.parse(skipButton) ? oldAccountModal() : newAccountModal()}
      </Fragment>
    );
  };
  const addAttribute = () => {
    setNum((prev) => prev + 1);
    values.attributesArr.push({ attribute: '', variations: { options: [] } });
    setValues({ ...values });
  };
  const removeAttribute = (i) => {
    values.attributesArr.splice(i, 1);
    setNum((prev) => prev - 1);
    setValues({ ...values });
    handleCombination();
  };
  let getProducts = (arrays) => {
    if (arrays.length === 0) {
      return [[]];
    }

    let results = [];
    getProducts(arrays.slice(1)).forEach((product) => {
      arrays[0].forEach((value) => {
        results.push([value].concat(product));
      });
    });

    return results;
  };

  let getAllCombinations = (options) => {
    let attributeNames = values.attributesArr.map((item) => item.attribute);
    let attributeValues = options;
    let checkEmptyOpions = attributeValues.filter((item) => item.length !== 0);
    if (checkEmptyOpions.length) {
      let emptyArrayIndexes = attributeValues
        .map((item, index) => {
          if (item.length === 0) {
            return index;
          }
        })
        .filter((und) => und !== undefined);
      attributeNames = attributeNames.filter(
        (i, index) => !emptyArrayIndexes.includes(index)
      );
      attributeValues = attributeValues.filter((item) => item.length !== 0);
    }
    let itemName = [];
    let varients = getProducts(attributeValues).map((product) => {
      let arr = [];
      let sinle = values.name;
      product.forEach((prod, index) => {
        sinle = index === 0 ? sinle + ' - ' + prod : sinle + ' /  ' + prod;
      });
      itemName.push(sinle);

      attributeNames.forEach((name, i) => {
        arr = [...arr, { [name]: product[i] }];
      });
      return arr;
    });
    return [itemName, varients];
  };

  const prepareAddItemGroups = (itemsArray, y) => {
    return itemsArray[0].map((item, index) => ({
      id: null,
      variant: itemsArray[1][index],
      lastindex: item.lastIndexOf('/'),
      sku: status.itemsList[index]?.sku || '',
      ean: status.itemsList[index]?.ean || '',
      upc: status.itemsList[index]?.upc || '',
      isbn: status.itemsList[index]?.isbn || '',
      unit: status.itemsList[index]?.unit || '',
      name: status.itemsList[index]?.updatedName || item,
      costPrice: status.itemsList[index]?.costPrice || null,
      updatedName: status.itemsList[index]?.updatedName || '',
      sellingPrice: status.itemsList[index]?.sellingPrice || null,
      reorderPoint: status.itemsList[index]?.reorderPoint || null,
    }));
  };
  const handleCombination = async () => {
    let x = values.attributesArr.map((val) => val.variations.options);
    let y = values.attributesArr.map((el) => ({
      attribute: el.attribute,
      variations: (el.variations && el.variations) || { options: [] },
    }));
    let allPossibleCombinations = getAllCombinations(x);

    let result = prepareAddItemGroups(allPossibleCombinations, y);
    status.itemsList = result;
    // values.itemsList = result;
    setValues({
      ...values,
      itemsList: result,
    });
    setComboList(allPossibleCombinations[0]);
  };
  const handleRemoveItem = (val, index) => {
    status.itemsList.splice(index, 1);
    setStatus({ ...status });
    // handleCombination();
  };

  const copyAllValue = (copy) => {
    let copiedValue = status.itemsList[0][copy];
    copiedValue = copiedValue ? copiedValue : 0;
    status.itemsList.forEach(function (item, index) {
      item[copy] = copiedValue;
    });
    setStatus({ ...status });
  };

  const generateSku = () => {
    setFieldValue('skuLoading', true);
    restRequest('get', `itemgroups/generatesku/${status.itemsList.length}`)
      .then((res) => {
        status.itemsList.forEach(function (item, index) {
          item.sku = res[index];
        });
        setStatus({ ...status });
        setFieldValue('skuLoading', false);
      })
      .catch((error) => {
        setFieldValue('skuLoading', false);
        handleToast(error, 'error');
        checkError(error);
      });
  };

  const handleItemPriceChange = (unitPriceValue, index, field) => {
    let unitPrice = unitPriceValue.floatValue;
    if (unitPrice > 0) {
      let unitPriceString = unitPrice.toString();
      // Price_Quantity_Limit
      // price and quantity limit from 5 digits to 10 digits
      if (unitPriceString.length > 10) {
        unitPriceString = unitPriceString.slice(0, 10);
      }
      if (field === 'reorderPoint') unitPrice = parseInt(unitPriceString);
      else unitPrice = parseFloat(unitPriceString);
    }
    status.itemsList[index][field] = unitPrice;
    setStatus({ ...status });
  };
  const togglePopover = (key) => {
    setPopovers({
      // ...popovers,
      [key]: !popovers[key],
    });
  };

  const handleArrowsKey = (e, index, fieldname) => {
    if (e.key === 'ArrowDown' && index + 1 < status?.itemsList?.length) {
      const element = document.getElementById(
        `itemsList[${index + 1}].${fieldname}`
      );
      setTimeout(() => {
        element.select();
        element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, 100);
    }
  };

  const handleArrowUpKey = (e, index, fieldname) => {
    if (e.key === 'ArrowUp' && index - 1 >= 0) {
      const element = document.getElementById(
        `itemsList[${index - 1}].${fieldname}`
      );
      element.select();
      element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  };

  const renderCombinationList = () => (
    <table
      style={{ width: '100%' }}
      className="list-table form-table border create_sales_order  horizontal-main-set item-group-tbl form-focus"
    >
      <thead>
        <tr>
          <th>
            <span className="th-title">{t('Items.item_name')}</span>
          </th>
          <th className="left-align">
            <div
              className={`${
                values.skuLoading ? 'd-flex td-group-inner' : 'td-group-inner'
              }`}
            >
              <span className="sku-span">
                {t('Items.sku')}
                <span className="red"> *</span>
              </span>
              {values.skuLoading ? (
                <span className="display-flex-row-reverse">
                  <SmallLoader />
                </span>
              ) : (
                <button
                  className="attribute_btn float-left w-100 group-btn-sm"
                  type="button"
                  onClick={() => generateSku()}
                >
                  {t('Items.generate_sku')}
                </button>
              )}
            </div>
          </th>
          <th className="left-align">
            <div className="td-group-inner_2">
              <span className="th-title">{t('Items.cost_price')}</span>
              <span className="icon_div">
                <MdHelpOutline
                  className="material-icon blue-icon help"
                  style={{ marginRight: '1.7rem' }}
                />
                <div className="tooltip_tooltip">
                  {t('Items.cost_price_as_opening_stock')}
                </div>
              </span>
              {/* <button
                className="attribute_btn float-left w-100 group-btn-sm"
                type="button"
                onClick={() => copyValue('costPrice')}
              >
                Copy to all
              </button> */}

              <PopOver
                title={t('Items.copy_to_all')}
                titleClass="group-btn-sm"
                mainClassName="float-left"
                titleClick={() => togglePopover('costPrice')}
                show={popovers.costPrice}
                cancelHandler={() => togglePopover('costPrice')}
                onYesClickHandler={() => {
                  copyAllValue('costPrice');
                  togglePopover('costPrice');
                }}
              >
                <div>
                  {`${t('Items.would_you_like')} ${
                    status.itemsList[0]['costPrice'] || 0
                  } ${t('Items.amount_to_be_reflected')}`}
                </div>
              </PopOver>
            </div>
          </th>
          <th className="left-align">
            <span className="th-title">{t('Items.selling_price')}</span>
            {/* <button
              className="attribute_btn float-left w-100 group-btn-sm"
              type="button"
              onClick={() => copyValue('sellingPrice')}
            >
              Copy to all
            </button> */}

            <PopOver
              title={t('Items.copy_to_all')}
              titleClass="group-btn-sm"
              mainClassName="float-left"
              titleClick={() => togglePopover('sellingPrice')}
              show={popovers.sellingPrice}
              cancelHandler={() => togglePopover('sellingPrice')}
              onYesClickHandler={() => {
                copyAllValue('sellingPrice');
                togglePopover('sellingPrice');
              }}
            >
              <div>
                {`${t('Items.would_you_like')} ${
                  status.itemsList[0]['sellingPrice'] || 0
                } ${t('Items.amount_to_be_reflected')}`}
              </div>
            </PopOver>
          </th>
          <th className="left-align">
            <span className="th-title">{t('common.upc')}</span>
          </th>
          <th className="right-align">
            <span className="th-title">{t('common.ean')}</span>
          </th>
          <th className="left-align">
            <span className="th-title">{t('common.isbn')}</span>
          </th>
          <th className="left-align">
            <span className="th-title">{t('Items.reorder_level')}</span>
            {/* <button
              className="attribute_btn float-left w-100 group-btn-sm"
              type="button"
              onClick={() => copyValue('reorderPoint')}
            >
              Copy to all
            </button> */}

            <PopOver
              title={t('Items.copy_to_all')}
              titleClass="group-btn-sm"
              titleClick={() => togglePopover('reorderPoint')}
              show={popovers.reorderPoint}
              cancelHandler={() => togglePopover('reorderPoint')}
              onYesClickHandler={() => {
                copyAllValue('reorderPoint');
                togglePopover('reorderPoint');
              }}
            >
              <div>
                {`${t('Items.would_you_like')} ${
                  status.itemsList[0]['reorderPoint'] || 0
                } ${t('Items.amount_to_be_reflected')}`}
              </div>
            </PopOver>
          </th>
          <th className="right-align item-group-heading"></th>
        </tr>
      </thead>
      <tbody>
        {status.itemsList &&
          status.itemsList.map((item, index) => (
            <tr
              key={index}
              className="table--row table_row_desc item-group-items"
            >
              <td className="left-align no-padding icon_div item_group_add">
                <Field
                  size="large"
                  id={`itemsList[${index}].name`}
                  // autoFocus={true}
                  value={item.name}
                  type="text"
                  handleChange={(change) => {
                    status.itemsList[index].name = change.target.value;
                    status.itemsList[index].updatedName = change.target.value;
                    setStatus({ ...status });
                  }}
                  required
                  error={getError(errors, touched, `itemsList[${index}].name`)}
                  onBlur={handleBlur}
                />
                <span className="icon_div">
                  <div className="tooltip_tooltip">
                    {item.name === '' ? <p>{t('Items.no_data')}</p> : item.name}
                  </div>
                </span>
              </td>
              <td className="left-align no-padding">
                <Field
                  size="large"
                  id={`itemsList[${index}].sku`}
                  // autoFocus={true}
                  value={item.sku}
                  handleChange={(change) => {
                    status.itemsList[index].sku = change.target.value;
                    setStatus({ ...status });
                  }}
                  required
                  error={getError(errors, touched, `itemsList[${index}].sku`)}
                  onBlur={() =>
                    setFieldTouched(`itemsList[${index}].sku`, true)
                  }
                  onKeyDown={(e) => handleArrowsKey(e, index, 'sku')}
                  onKeyUp={(e) => handleArrowUpKey(e, index, 'sku')}
                />
              </td>
              <td className="left-align no-padding">
                <Field
                  size="large"
                  id={`itemsList[${index}].costPrice`}
                  placeholder={'0'}
                  type="number"
                  decimalScale={2}
                  thousandSeparator=","
                  value={item.costPrice}
                  disabled={false}
                  allowNegative={false}
                  onValueChange={(values) =>
                    handleItemPriceChange(values, index, 'costPrice')
                  }
                  error={getError(
                    errors,
                    touched,
                    `itemsList[${index}].costPrice`
                  )}
                  onBlur={() =>
                    setFieldTouched(`itemsList[${index}].costPrice`, true)
                  }
                  onKeyDown={(e) => handleArrowsKey(e, index, 'costPrice')}
                  onKeyUp={(e) => handleArrowUpKey(e, index, 'costPrice')}
                />
              </td>
              <td className="left-align no-padding">
                <Field
                  size="large"
                  placeholder={'0'}
                  type="number"
                  decimalScale={2}
                  thousandSeparator=","
                  id={`itemsList[${index}].sellingPrice`}
                  disabled={false}
                  allowNegative={false}
                  onValueChange={(values) =>
                    handleItemPriceChange(values, index, 'sellingPrice')
                  }
                  value={item.sellingPrice}
                  error={getError(
                    errors,
                    touched,
                    `itemsList[${index}].sellingPrice`
                  )}
                  onBlur={() =>
                    setFieldTouched(`itemsList[${index}].sellingPrice`, true)
                  }
                  onKeyDown={(e) => handleArrowsKey(e, index, 'sellingPrice')}
                  onKeyUp={(e) => handleArrowUpKey(e, index, 'sellingPrice')}
                />
              </td>
              <td className="left-align no-padding">
                <Field
                  size="large"
                  id={`itemsList[${index}].upc`}
                  value={item.upc}
                  handleChange={(change) => {
                    status.itemsList[index].upc = change.target.value;
                    setStatus({ ...status });
                  }}
                  required
                  error={getError(errors, touched, `itemsList[${index}].upc`)}
                  onBlur={handleBlur}
                  onKeyDown={(e) => handleArrowsKey(e, index, 'upc')}
                  onKeyUp={(e) => handleArrowUpKey(e, index, 'upc')}
                />
              </td>
              <td className="left-align no-padding">
                <Field
                  size="large"
                  id={`itemsList[${index}].ean`}
                  value={item.ean}
                  handleChange={(change) => {
                    status.itemsList[index].ean = change.target.value;
                    setStatus({ ...status });
                  }}
                  required
                  error={getError(errors, touched, `itemsList[${index}].ean`)}
                  onBlur={handleBlur}
                  onKeyDown={(e) => handleArrowsKey(e, index, 'ean')}
                  onKeyUp={(e) => handleArrowUpKey(e, index, 'ean')}
                />
              </td>
              <td className="left-align no-padding">
                <Field
                  size="large"
                  id={`itemsList[${index}].isbn`}
                  value={item.isbn}
                  handleChange={(change) => {
                    status.itemsList[index].isbn = change.target.value;
                    setStatus({ ...status });
                  }}
                  required
                  error={getError(errors, touched, `itemsList[${index}].isbn`)}
                  onBlur={handleBlur}
                  onKeyDown={(e) => handleArrowsKey(e, index, 'isbn')}
                  onKeyUp={(e) => handleArrowUpKey(e, index, 'isbn')}
                />
              </td>
              <td className="left-align no-padding">
                <Field
                  size="large"
                  id={`itemsList[${index}].reorderPoint`}
                  value={parseInt(item.reorderPoint)}
                  type="number"
                  decimalScale={2}
                  thousandSeparator=","
                  allowNegative={false}
                  onValueChange={(values) =>
                    handleItemPriceChange(values, index, 'reorderPoint')
                  }
                  placeholder={'0'}
                  error={getError(
                    errors,
                    touched,
                    `itemsList[${index}].reorderPoint`
                  )}
                  onBlur={() =>
                    setFieldTouched(`itemsList[${index}].reorderPoint`, true)
                  }
                  onKeyDown={(e) => handleArrowsKey(e, index, 'reorderPoint')}
                  onKeyUp={(e) => handleArrowUpKey(e, index, 'reorderPoint')}
                />
              </td>

              <td className="list-table--amount right-align">
                <button
                  type="button"
                  disabled={
                    status.itemsList.length === 1 &&
                    status.itemsList[0].id === null
                  }
                  className="close-btn button"
                  onClick={(option) => handleRemoveItem(item, index)}
                >
                  <DeleteIcon />
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );

  const renderAttributeProps = (i) => {
    const inputAttributes = {
      value: values.attributesArr[i].attribute,
      onChange: (event, { newValue }) => {
        if (event.target.id !== 'remove') {
          values.attributesArr[i].attribute = newValue;
          values.attributesArr[i].variations.options = [];
          setValues({ ...values });
        }
      },
      onBlur: () => setFieldTouched(`values.attributesArr${[i]}`),
    };
    return inputAttributes;
  };
  const handlechangeOption = (option, i) => {
    if (option) {
      values.attributesArr[i].variations.options =
        (option && [...option.map((a) => a.value)]) || [];
      setComboFlag((prev) => !prev);
    } else {
      values.attributesArr[i].variations.options = [];
      setComboFlag((prev) => !prev);
    }
  };

  const renderAttributeOptions = () =>
    values.attributesArr.map((item, i) => (
      <div
        key={i}
        id={'item_attribute_' + i}
        className="d-flex item-group-inner"
      >
        <Field
          className="attributes-field"
          type="autosuggest"
          name={t('Items.attributes')}
          id={'item_attribute_' + i}
          value={item.attribute}
          placeholder="Color, Storage, Size"
          suggestions={attributeSuggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequestedAttribute}
          onSuggestionsClearRequested={onSuggestionsClearRequestedAttribute}
          removeSuggestion={false}
          inputProps={renderAttributeProps(i)}
          required={values.type === 'goods'}
          error={getError(errors, touched, `attributesArr[${i}].attribute`)}
          onBlur={handleBlur}
        />
        <Field
          size="large"
          type="badge"
          name={t('Items.options')}
          addType="itemBadge"
          dropdownValue={values?.attributesArr[i]?.variations.options}
          // autoFocus={true}
          className={`full_width email_dropdown group_option ${
            submitCount > 0 &&
            values.attributesArr[i].variations.options.length === 0
              ? 'error'
              : ''
          }`}
          id={'item_attribute_opt' + i}
          handleChange={(option) => {
            handlechangeOption(option, i);
          }}
          required
          error={
            submitCount > 0 &&
            values.attributesArr[i].variations.options.length === 0 &&
            t('common.validation.required')
          }
          onBlur={handleBlur}
        />

        <button
          className="group_delete_btn"
          type="button"
          onClick={() => num > 1 && removeAttribute(i, item)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.5"
            height="15"
            viewBox="0 0 12.5 15"
          >
            <path
              d="M9.375-15a1.217,1.217,0,0,0-.9.352,1.217,1.217,0,0,0-.352.9v.625H4.375v1.25H5v10A1.8,1.8,0,0,0,5.557-.557,1.8,1.8,0,0,0,6.875,0h7.5a1.8,1.8,0,0,0,1.318-.557,1.8,1.8,0,0,0,.557-1.318v-10h.625v-1.25h-3.75v-.625a1.217,1.217,0,0,0-.352-.9,1.217,1.217,0,0,0-.9-.352Zm0,1.25h2.5v.625h-2.5ZM6.25-11.875H15v10a.6.6,0,0,1-.186.439.6.6,0,0,1-.439.186h-7.5a.6.6,0,0,1-.439-.186.6.6,0,0,1-.186-.439ZM7.5-10v6.875H8.75V-10ZM10-10v6.875h1.25V-10Zm2.5,0v6.875h1.25V-10Z"
              transform="translate(-4.375 15)"
            ></path>
          </svg>
        </button>
      </div>
    ));

  const inputProps = {
    value: values.unit,
    onChange: (event, { newValue }) => {
      if (event.target.id !== 'remove') {
        setFieldValue('unit', newValue);
      }
    },
    onBlur: () => setFieldTouched('unit'),
  };

  let jango;
  let dummyArr = [];
  allWarehouses.forEach(function (allWare) {
    jango = false;
    values.warehouses.forEach(function (ware) {
      if (allWare.id === ware.id) {
        jango = true;
      }
    });
    if (jango === false) {
      dummyArr.push(allWare);
    }
  });
  const handleName = (val) => {
    setFieldValue('name', val);
    !createComboFlag && handleCombination();
  };
  status.warehousesList = dummyArr;
  return (
    <Fragment>
      {renderModals()}
      <Form
        className="item-form item-group-form"
        onSubmit={(event) => {
          formSubmit(
            event,
            values.warehouses,
            setFieldValue,
            handleSubmit,
            'id',
            'warehouses',
            t
          );
          props.handleStep();
        }}
        type={inModalItem && 'modal'}
      >
        <FormSection title={t('Items.item_info')}>
          <div
            className="form-image images-uploading"
            id="Click_Add_Item_Image"
          >
            <Field
              type="image"
              name={t('Items.add_images')}
              accept="image/*"
              onDrop={handleFiles}
              maxSize={5 * 1000 * 1000}
              // multiple  disabled multiple image upload
              camIconflag={true}
            />
            <ImagePreview
              images={[...values.images, ...values.uploadImages]}
              onDeleteImage={handleImageDelete}
            />
          </div>
          <div className="form-fields-container d-flex flex-wrap  position-relative item-group-main">
            <div className="position-relative flex-100">
              <Field
                className="full-width-item-name"
                size="large"
                name={t('Items.item_name')}
                id="name"
                autoFocus={true}
                value={values.name}
                handleChange={(e) => handleName(e.target.value)}
                onBlur={handleBlur}
                required
                error={(touched.name || submitCount > 0) && errors.name}
              />
              <p className="form-field--side-btn maximum_char">
                {t('Items.max_characters')}
              </p>
            </div>
            <div className="d-flex flex-wrap w-100">
              <div className="group_main_set flex-60 d-flex flex-wrap">
                <Field
                  className="flex-50"
                  type="autosuggest"
                  name={t('Items.unit')}
                  id="unit"
                  value={values.unit}
                  placeholder="m, kg, litre"
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={onSuggestionsClearRequested}
                  /*removeSuggestion={removeSuggestion}*/
                  removeSuggestion={false}
                  inputProps={inputProps}
                  required={values.type === 'goods'}
                  error={(touched.unit || submitCount > 0) && errors.unit}
                />
                <Field
                  className="flex-50"
                  name={t('Items.manufacturer')}
                  id="manufacturer"
                  value={values.manufacturer}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.manufacturer && errors.manufacturer}
                />

                <Field
                  className="flex-50"
                  name={t('Items.brand')}
                  id="brand"
                  value={values.brand}
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.brand && errors.brand}
                />
                <Field
                  className="flex-50"
                  type="dropdown"
                  name={t('Items.item_tax')}
                  id="taxID"
                  value={values.taxID}
                  options={status.taxList}
                  dropdownValue="id"
                  dropdownLabel="name"
                  handleChange={(option) => handleTaxChange(option)}
                  addButton={inModalItem ? false : true}
                />
                {accountDropDownField('purchase')}
                {accountDropDownField('sales')}
              </div>
              <div className="description-set flex-40">
                <Field
                  className="w-100 flex-100 d-block h-100"
                  size="large"
                  type="textarea"
                  name={t('Items.description')}
                  id="description"
                  value={values.description}
                  handleChange={handleChange}
                  error={
                    (touched.description || submitCount > 0) &&
                    errors.description
                  }
                />
              </div>
            </div>
          </div>
          <div className="add-items-desc-sec ">
            {type === 'add' && (
              <div id="top_div" className="d-inline">
                {num < 3 && (
                  <button
                    className="attribute_btn attribute_btn_set "
                    type="button"
                    onClick={() => num < 3 && addAttribute()}
                  >
                    {t('Items.add_new_attribute')}
                  </button>
                )}
              </div>
            )}
            {type === 'add' && renderAttributeOptions()}
            {type === 'add' && Boolean(values.attributesArr.length) && (
              <div onClick={handleCombination} className="combiation_set">
                {t('Items.show_combination')}
              </div>
            )}
            {type === 'add' && comboList.length > 0 && renderCombinationList()}
          </div>
        </FormSection>

        <FormAction
          disabled={isSubmitting}
          submitLabel={submitButtonText}
          marginFromRight={0}
          type="button"
          onSubmit={handleSubmit}
          onCancel={() => {
            let dataFromLS = getObjFromLS('module');
            let redirectUrl = '';
            if (dataFromLS && dataFromLS.moduleName === 'item_groups') {
              redirectUrl = dataFromLS.queryParam;
            }
            if (inModalItem) {
              closeItem();
            } else if (
              window.location.pathname.includes('add') ||
              window.location.pathname.includes('edit')
            ) {
              history.push('/item-groups' + redirectUrl);
            } else {
              setObjInLS('module', { ...dataFromLS, action: null });
              history.push('/r');
            }
          }}
        />

        <ErrorFocus />
      </Form>
    </Fragment>
  );
};

export default formEnhancer(ItemGroupForm);
